import React from 'react';
import { Form, FormField, FormProps, ValidationError } from '@gik/ui/Form';
import { recipientAddressFormSchema } from './RecipientAddressFormSchema';
import { FormApi, SubmissionErrors } from 'final-form';
import { ShippingDetails } from '@gik/checkout/types';
import { FormRenderProps } from 'react-final-form';

export interface IRecipientAddressFormProps extends FormProps {
  form?: FormRenderProps;
  required?: boolean;
  formId?: string;
  onBeforeSubmit?: (
    values: object,
    form: FormApi<object, object>
  ) => void | SubmissionErrors | Promise<SubmissionErrors>;
}

export interface IRecipientAddressFormValues {
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface IRecipientAddressFormErrors {
  address1: ValidationError;
  address2: ValidationError;
  city: ValidationError;
  state: ValidationError;
  postalCode: ValidationError;
}

export function RecipientAddressForm({
  initialValues,
  onSubmit,
  onBeforeSubmit,
  form,
  formId,
  required,
  ...otherProps
}: IRecipientAddressFormProps): React.ReactElement {
  async function handleSubmit(values: ShippingDetails, form: FormApi<object, object>): Promise<void> {
    if (onBeforeSubmit) onBeforeSubmit(values, form);
    if (onSubmit) onSubmit(values, form);
  }

  const fields = () => (
    <>
      <FormField name="country" inline />
      <FormField name="address1" />
      <FormField name="address2" />
      <section>
        <FormField name="city" className="tw-flex-1" />
        <FormField name="state" />
        <FormField name="postalCode" />
      </section>
    </>
  );

  if (form) return fields();

  return (
    <Form
      id={formId}
      onSubmit={handleSubmit}
      schema={recipientAddressFormSchema(required)}
      initialValues={initialValues}
      vertical
      validateOnBlur={false}
      {...otherProps}
      render={() => fields}
    />
  );
}
